import { formatBooleanValue } from "../../..";
import { IAttribute } from "../../../model/formconfiguration/Attribute";
import FormConfigSectionQualifier, {
  IFormConfigSectionQualifier
} from "../../../model/formconfiguration/FormConfigSectionQualifier";
import { IQualifier } from "../../../model/formconfiguration/Qualifier";
import Section, { ISection } from "../../../model/formconfiguration/Section";
import FormConfigQualifierAttribute, {
  IFormConfigQualifierAttribute
} from "../FormConfigQualifierAttribute";

let formSectionListMapper = (json: any[] = []) => {
  let formSections = json.map((item: any) => {
    let section = Section(item);
    section.valid = formatBooleanValue(item.valid);
    section.orderNumberVisible = formatBooleanValue(item.orderNumberVisible);
    section.labelVisible = formatBooleanValue(item.labelVisible);
    section.required = formatBooleanValue(item.required);
    section.portalAggregate = formatBooleanValue(item.portalAggregate)

    return section;
  });
  return formSections;
};

let formConfigSectionQualifierListMapper = (
  json: any[] = [],
  qualifiers: IQualifier[]
): IFormConfigSectionQualifier[] => {
  return json.map((item: any) => {
    let formConfigSectionQualifier = FormConfigSectionQualifier(item);
    formConfigSectionQualifier.labelVisible = formatBooleanValue(
      item.labelVisible
    );
    formConfigSectionQualifier.orderNumberVisible = formatBooleanValue(
      item.orderNumberVisible
    );
    formConfigSectionQualifier.required = formatBooleanValue(item.required);
    formConfigSectionQualifier.valid = formatBooleanValue(item.valid);
    formConfigSectionQualifier.visiblePublic = formatBooleanValue(
      item.visiblePublic
    );
    let qualifier = qualifiers.find(
      (qualifier: IQualifier) =>
        qualifier.code === formConfigSectionQualifier.qualifierCode
    );
    formConfigSectionQualifier.qualifier = qualifier || ({} as IQualifier);
    return formConfigSectionQualifier;
  });
};

let formConfigQualifierAttributeListMapper = (
  json: any[] = [],
  attributes: IAttribute[]
): IFormConfigQualifierAttribute[] => {
  return json.map((item: any) => {
    let formConfigQualifierAttribute = FormConfigQualifierAttribute(item);
    formConfigQualifierAttribute.labelVisible = formatBooleanValue(
      item.labelVisible
    );
    formConfigQualifierAttribute.required = formatBooleanValue(item.required);
    formConfigQualifierAttribute.shortDisplay = formatBooleanValue(
      item.shortDisplay
    );
    formConfigQualifierAttribute.validation = formatBooleanValue(
      item.validation
    );
    formConfigQualifierAttribute.visible = formatBooleanValue(item.visible);
    let attribute = attributes.find(
      (attribute: IAttribute) =>
        attribute.code === formConfigQualifierAttribute.attributeCode
    );
    formConfigQualifierAttribute.attribute = attribute || ({} as IAttribute);
    return formConfigQualifierAttribute;
  });
};

const groupSubsections = (
  allFormSections: ISection[],
  sectionToBeGrouped = allFormSections,
  topLevelGroupation: boolean = true
) => {
  let groupedSections: ISection[] = [];
  sectionToBeGrouped.forEach((parentFormSection) => {
    if (!topLevelGroupation || !parentFormSection.formSectionId) {
      let childSections: ISection[] = [];
      allFormSections.forEach((section) => {
        if (parentFormSection.id === section.formSectionId) {
          childSections.push(section);
        }
      });
      let subsections = groupSubsections(allFormSections, childSections, false);
      if (subsections) {
        parentFormSection.subsections = subsections;
        groupedSections.push(parentFormSection);
      }
    }
  });
  return groupedSections;
};

const FormConfigurationDetailsMapper = (
  formSectionsJSON: any[],
  formSectionQualifiersJSON: any[],
  formQualifierAttributesJSON: any[],
  qualifiers: IQualifier[],
  attributes: IAttribute[]
) => {
  let formSections = formSectionListMapper(formSectionsJSON);
  let formSectionQualifiers = formConfigSectionQualifierListMapper(
    formSectionQualifiersJSON,
    qualifiers
  );
  let formQualifierAttributes = formConfigQualifierAttributeListMapper(
    formQualifierAttributesJSON,
    attributes
  );

  formSections = formSections.map((formSection: ISection) => {
    let qualifiers = formSectionQualifiers.filter(
      (formSectionQualifier: IFormConfigSectionQualifier) =>
        formSectionQualifier.formSectionId === formSection.id
    );

    qualifiers = qualifiers.map((qualifier: IFormConfigSectionQualifier) => {
      let attributes = formQualifierAttributes.filter(
        (attribute: IFormConfigQualifierAttribute) =>
          attribute.qualifierCode === qualifier.qualifierCode
      );
      qualifier.attributes = attributes;
      return qualifier;
    });
    formSection.qualifiers = qualifiers;
    return formSection;
  });
  return groupSubsections(formSections);
};

export default FormConfigurationDetailsMapper;
